"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
const getContentUrl = (product) => {
    var _a, _b, _c;
    const slug = (_c = (_b = (_a = product.masterData) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.slug) === null || _c === void 0 ? void 0 : _c['en-US'];
    const productTypeSlug = (() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const productTypeKey = (_b = (_a = product.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key;
        const isSubscription = productTypeKey === mxp_schemas_1.Product.ProductType.SUBSCRIPTION;
        return isSubscription
            ? (_g = (_f = (_e = (_d = (_c = product.masterData) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.masterVariant.attributes) === null || _e === void 0 ? void 0 : _e.find((a) => a.name === 'subscriptionProductType')) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.key : mxp_schemas_1.Product.ProductTypesSlugsMap[productTypeKey];
    })();
    return createUrl(productTypeSlug, slug);
};
exports.getLineItemProductUrl = (lineItem) => {
    const slug = lineItem.productSlug;
    const productTypeSlug = (() => {
        var _a, _b;
        const productTypeKey = lineItem.productType;
        const isSubscription = productTypeKey === mxp_schemas_1.Product.ProductType.SUBSCRIPTION;
        return isSubscription
            ? (_b = (_a = lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.subscriptionProductType.key : mxp_schemas_1.Product.ProductTypesSlugsMap[productTypeKey];
    })();
    return createUrl(productTypeSlug, slug);
};
const createUrl = (productTypeSlug, slug) => `/${mxp_schemas_1.Content.CategorySlugs.CPE_LEARNING}/${productTypeSlug}/${slug}`;
exports.default = getContentUrl;
//# sourceMappingURL=getProductUrl.js.map